<template>
  <Dialog
    width="608px"
    titleAlign="center"
    title="音疯更名为Mureka"
    :subTitle="null"
    :hideCloseBtn="createRenderType == 'pc' ? false : true"
    :showBottomCloseBtn="createRenderType == 'pc' ? false : true"
    :visible="visible"
    @close="closeDialog"
    background="linear-gradient(130deg, #5325A2 0%, #7D6FD6 47%, #501269 100%)"
    :backgroundImage="false"
    :customClass="`${createRenderType}-yinfeng-dialog yinfeng-dialog`"
  >
    <div>
      <div class="tip-text">用户您好，</div>
      <div class="tip-text">
        音疯于2025年5月28日正式更名为Mureka，域名变更为mureka.cn，并对部分产品功能进行升级调整。
        更名后，您的音疯会员权益、积分余额将于24小时内同步迁移至Mureka。
        给您造成的不便，敬请谅解。如需帮助，请联系help@mureka.ai。
      </div>
      <div class="btn-group">
        <div class="btn btn-show" @click="closeDialog">我知道了</div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { defineProps, defineEmits, getCurrentInstance, onMounted } from "vue"
import { useRouter } from "vue-router"
import { storeToRefs } from "pinia"

import useCreateLayoutStore from "@/store/create/createLayoutStore.js"

const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  isFirst: {
    type: Boolean,
    default: true,
  },
})
const emits = defineEmits(["updata:visible", "updata: isFirst"])

const closeDialog = () => {
  emits("update:visible", false)
}

const init = () => {}

onMounted(() => {
  init()
})
</script>

<style lang="scss" scoped>
.yinfeng-dialog {
  position: relative;
  .tip-text{
    margin: 10px 30px;
    color: #fff;
  }
  .btn-group {
    display: flex;
    margin: 30px;
    gap: 30px;
    .btn {
      flex: 1; /* 每个按钮平分父容器宽度 */
      padding: 10px 0; /* 添加一些内边距 */
      font-size: 16px; /* 设置字体大小 */
      text-align: center;
      border-radius: 20px;
      
      &.btn-show {
        background: linear-gradient(
          91deg,
          #4fdeff -40%,
          #d9f8ff 52%,
          #e675ff 132%
        );
        color: #000;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .yinfeng-dialog {
  }
}
</style>
